/**
 * 日本語翻訳ファイル
 */

export default {
  // 共通
  common: {
    loading: '読み込み中...',
    saving: '保存中...',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    search: '検索',
    close: '閉じる',
    confirm: '確認',
    yes: 'はい',
    no: 'いいえ',
    error: 'エラー',
    success: '成功',
    unknown: '不明'
  },

  // ナビゲーション
  nav: {
    dashboard: 'ダッシュボード',
    pages: '保存ページ',
    subscription: 'プラン',
    settings: '設定',
    logout: 'ログアウト',
    upgrade: 'アップグレード',
    freeUpgrade: 'Free → Upgrade'
  },

  // ヘッダー
  header: {
    tagline: '記憶のガイド',
    currentPlan: '現在のプラン',
    premiumUpgrade: 'プレミアムにアップグレード →'
  },

  // ダッシュボード
  dashboard: {
    greeting: 'こんにちは、{name}さん',
    greetingDefault: 'こんにちは、ユーザーさん',
    subtitle: '今日はどんな情報を探しますか？',
    savedPages: '保存ページ',
    aiSearch: 'AI検索',
    plan: 'プラン',
    unit: '件',
    unitPerMonth: '回/月',
    recentSaves: '最近の保存',
    viewAll: 'すべて見る →',
    gettingStarted: 'はじめてのKnoVelo',
    step1: 'Chrome拡張機能をインストールして、気になるページを保存しましょう',
    step2: '保存されたページは自動でAIが要約とタグを生成します',
    step3: '右側のThothに「昨日見た赤い橋のページ」のように質問してみましょう'
  },

  // Thoth チャットボット
  thoth: {
    name: 'Thoth',
    tagline: 'あなたの記憶のガイド',
    welcome: `こんにちは！私はThoth、あなたの記憶のガイドです。

「昨日見た赤い橋のページ」「先週調べたラーメン屋」のように、曖昧な記憶でも大丈夫。あなたの保存したページから探してみます。

何をお探しですか？`,
    placeholder: '「昨日見た赤い橋」など、曖昧でもOK',
    remainingSearch: '残り検索',
    times: '回',
    suggestions: {
      yesterday: '昨日見たページ',
      lastWeekNews: '先週のニュース',
      techArticle: '技術記事',
      readLater: '後で読む'
    },
    noPages: 'まだページが保存されていないようです。Chrome拡張機能でページを保存すると、後から曖昧な記憶でも探せるようになりますよ！',
    limitReached: '今月のAI検索回数が上限に達しました。',
    limitReachedPremium: '来月のリセットをお待ちください。',
    limitReachedFree: 'プレミアムプランにアップグレードすると、月100回まで検索できます。',
    voiceInputStart: '音声で入力',
    voiceInputStop: '音声入力を停止',
    speak: '読み上げ',
    stopSpeaking: '停止',
    feedbackThanks: 'フィードバックありがとうございます',
    feedbackQuestion: '役に立ちましたか？',
    feedbackGood: '役に立った',
    feedbackBad: '役に立たなかった',
    disclaimer: 'ThothはAIのため、回答を誤ることがあります。'
  },

  // 設定
  settings: {
    title: '設定',
    account: 'アカウント',
    plan: 'プラン',
    registeredDate: '登録日',
    appSettings: 'アプリ設定',
    theme: 'テーマ',
    themeLight: 'ライト',
    themeDark: 'ダーク（今後対応）',
    notifications: '通知',
    notificationsDesc: 'ブラウザ通知を受け取る',
    saveSettings: '設定を保存',
    settingsSaved: '設定を保存しました',
    settingsSaveError: '設定の保存に失敗しました',
    dataManagement: 'データ管理',
    dataExport: 'データエクスポート',
    dataExportDesc: '保存したページをJSON形式でダウンロード',
    exportBadge: 'VIP以降',
    logoutConfirm: 'ログアウトしますか？'
  },

  // 保存ページ
  pages: {
    title: '保存ページ',
    searchPlaceholder: 'タイトルやキーワードで検索...',
    noPages: 'まだページが保存されていません',
    noPagesDesc: 'Chrome拡張機能でページを保存してみましょう',
    noResults: '検索結果がありません',
    noResultsDesc: '別のキーワードで試してみてください',
    savedAt: '保存日時',
    tags: 'タグ',
    summary: '要約',
    visitPage: 'ページを開く',
    deleteConfirm: 'このページを削除しますか？',
    deleteSuccess: 'ページを削除しました',
    deleteError: 'ページの削除に失敗しました'
  },

  // サブスクリプション
  subscription: {
    title: 'プランを選択',
    subtitle: 'あなたに合ったプランでKnoVeloをお楽しみください',
    free: 'Free',
    pro: 'Pro',
    popular: 'おすすめ',
    current: '現在のプラン',
    upgrade: 'アップグレード',
    upgrading: '処理中...',
    comingSoon: '近日公開',
    preparing: '準備中',
    currentProPlan: '現在 Pro プランをご利用中です',
    manageSubscription: 'サブスクリプションを管理',
    success: 'ご購入ありがとうございます！Proプランが有効になりました。',
    canceled: 'チェックアウトがキャンセルされました。',
    stripeNotConfigured: 'Stripeが設定されていません。管理者にお問い合わせください。',
    checkoutError: 'チェックアウトセッションの作成に失敗しました',
    portalError: 'サブスクリプション管理ページを開けませんでした',
    pricePerMonth: '/月',
    freePrice: '無料',
    features: {
      savedPages: '保存ページ',
      aiSearch: 'AI検索'
    },
    faq: {
      title: 'よくある質問',
      cancel: {
        question: 'いつでもキャンセルできますか？',
        answer: 'はい、いつでもキャンセル可能です。キャンセル後も、現在の請求期間が終了するまでプレミアム機能をご利用いただけます。'
      },
      payment: {
        question: '支払い方法は何がありますか？',
        answer: 'クレジットカード（Visa、Mastercard、American Express）に対応しています。決済はStripeを通じて安全に処理されます。'
      },
      downgrade: {
        question: 'ダウングレードしたらデータはどうなりますか？',
        answer: '保存したページは削除されません。ただし、Freeプランの制限（500件）を超えている場合、新しいページの保存ができなくなります。'
      }
    }
  },

  // ログイン
  login: {
    title: 'KnoVeloへようこそ',
    subtitle: '記憶のガイドで、探しものをすぐに見つける',
    googleLogin: 'Googleでログイン',
    loginError: 'ログインに失敗しました'
  },

  // エラーメッセージ
  errors: {
    generic: '一時的にエラーが発生しました。しばらくしてからもう一度お試しください。',
    serverBusy: 'サーバーが混雑しています。しばらく待ってから再度お試しください。',
    networkError: 'ネットワークエラーが発生しました。接続を確認してください。'
  }
};
